import { render, staticRenderFns } from "./VProjectMoms.vue?vue&type=template&id=4c152d8d&"
import script from "./VProjectMoms.vue?vue&type=script&lang=js&"
export * from "./VProjectMoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports